import React from 'react';
import EmptyStateIcon from 'assets/svg/developer/empty-state.svg';
import { useLocale } from 'locale';
import { Text } from 'ds/components/typography';
import * as Styled from './styled';
import { Route } from 'config/routes';


const EmptyState: React.FC<{ isFiltered?: boolean, freeIntegration?: boolean }> = ({ isFiltered, freeIntegration }) => {
  const { t } = useLocale();

  return (
    <Styled.EmptyStateWrapper>
      <EmptyStateIcon />
      <Styled.EmptyStateDescription>
        <Text>
          {isFiltered
            ? t('developerPage.projects.emptyState')
            : (
              <>
                {t('developerPage.emptyState.text', { freeIntegration })}
                <Styled.EmptyStateLink routeName={Route.DevelopersSearchPage}>
                  {t('developerPage.emptyState.link', { freeIntegration })}
                </Styled.EmptyStateLink>
              </>
          )}
        </Text>
      </Styled.EmptyStateDescription>
    </Styled.EmptyStateWrapper>
  );
};

export default EmptyState;
